import { Injectable } from "@angular/core";
import { PacsInfo } from "../model/pacsinfo.model";
import { HttpServices } from "./httpservices/http.service";
import { EmitService } from './emit.service';
import { NgForm } from "@angular/forms";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { PacsEntry } from '../model/pacsentry.model'; 
import { UploadFileEntry } from '../model/uploadfileentry.model'; 
import { PacsOfPatient } from '../model/pacsofpatient.model'; 
@Injectable()

export class PacsRepository {

    private pacsList: PacsInfo[] = [];
    private dataCount : number;
    private uploadProgress  : number;
    private fileUploadReturnValue : any[] = [];
    private fileUploadNameList  : any[] = [];
    private patientList : PacsInfo[] = [];

    pagesList : number[]
    gotoPageNo : number;  //跳到那一页
    pageTotal : number;  //总页数
    firstPageShowFlag : boolean;  //首页按钮显示控制
    nextPageShowFlag : boolean;  //下页按钮显示控制
    priorPageShowFlag : boolean; //上页按钮显示控制
    lastPageShowFlag : boolean;  //尾页按钮显示控制
    pageDataCount : number = 20;  //每页的数据条数
    tableDataCount : number; //总数据条数
    currentPageNo : number = 1; //当前页号
    currentDataCycle : number = 1;

    getPagesList() {
        return this.pagesList;
    }
    setPagesList(pagesList) {
        this.pagesList = pagesList;
    }

    getGotoPageNo() {
        return this.gotoPageNo;
    }
    setGotoPageNo(gotoPageNo) {
        this.gotoPageNo = gotoPageNo;
    }

    getPageTotal() {
        return this.pageTotal;
    }
    setPageTotal(pageTotal) {
        this.pageTotal = pageTotal;
    }

    getFirstPageShowFlag() {
        return this.firstPageShowFlag;
    }
    setFirstPageShowFlag(firstPageShowFlag) {
        this.firstPageShowFlag = firstPageShowFlag;
    }
    getNextPageShowFlag() {
        return this.nextPageShowFlag;
    }
    setNextPageShowFlag(nextPageShowFlag) {
        this.nextPageShowFlag = nextPageShowFlag;
    }
    getPriorPageShowFlag() {
        return this.priorPageShowFlag;
    }
    setPriorPageShowFlag(priorPageShowFlag) {
        this.priorPageShowFlag = priorPageShowFlag;
    }
    getLastPageShowFlag() {
        return this.lastPageShowFlag;
    }
    setLastPageShowFlag(lastPageShowFlag) {
        this.lastPageShowFlag = lastPageShowFlag;
    }
    getPageDataCount() {
        return this.pageDataCount;
    }
    setPageDataCount(pageDataCount) {
        this.pageDataCount = pageDataCount;
    }
    getTableDataCount() {
        return this.tableDataCount;
    }
    setTableDataCount(tableDataCount) {
        this.tableDataCount = tableDataCount;
    }
    getCurrentPageNo() {
        return this.currentPageNo;
    }
    setCurrentPageNo(currentPageNo) {
        this.currentPageNo = currentPageNo;
    }
    getCurrentDataCycle() {
        return this.currentDataCycle;
    }
    setCurrentDataCycle(currentDataCycle) {
        this.currentDataCycle = currentDataCycle;
    }

    constructor(private dataSource: HttpServices, private event : EmitService) {

    }

    refreshPacsInfo(searchObj) {
        this.dataSource.pacsInfo(searchObj)
        .subscribe(p => {
            if(p.status == '1') {
                this.pacsList =p.resultInfo.returnList;
                this.tableDataCount = this.pacsList.length;
                this.event.sendPacsListMessage("001");
            }
            
    
        });
    }

   
    searchCripPatient(searchObj) {
        this.dataSource.searchPatientList(searchObj)
        .subscribe(p => {
            if(p.status == '1') {
                this.patientList = p.resultInfo.returnList;
                this.event.sendCripPatientSubjectMessage("001");
                
            }
        });
    }

   

    getCripPatientList() {
        return this.patientList;
    }
    
    getCripPatientInfo(patient_id) {
        return this.patientList[this.patientList.findIndex(p => p.patientID == patient_id)];
    }

    submitFiles(form, fileName) {
        this.dataSource.submitFiles(form)
        .subscribe(event => {
            console.log(event);
            this.fileUploadReturnValue.push(event);
            this.fileUploadNameList.push(fileName);
            this.event.sendPacsFileUploadSubjectMessage("001");

        });
    }

    saveFileInfo(p_id) {
        let pacsOfPatient = new PacsOfPatient();

        let fileList = new Array();
        for(let i = 0; i < this.fileUploadNameList.length; i++) {
            let aFile = new UploadFileEntry();
            aFile.filename = this.fileUploadNameList[i];
            aFile.fileinfo = this.fileUploadReturnValue[i];
            fileList.push(aFile);
        }
        pacsOfPatient.p_id = p_id;
        pacsOfPatient.filelist = fileList;
        // console.log(this.fileUploadReturnValue);
        // console.log(this.fileUploadNameList);
        this.dataSource.insertFilesInfo(pacsOfPatient)
                        .subscribe(event => {
                            this.event.sendAddFinishSubjectMessage("001");

                        });

    }

    getFileUploadNameList() {
        return this.fileUploadNameList;
    }

    getFileUploadReturnValue() {
        return this.fileUploadReturnValue;
    }

    getPacsInfo(id: string): PacsInfo {

        return this.pacsList.find(p => p.P_ID == id);

    }

    getPacsList(): PacsInfo[] {
        return this.pacsList;
    }

    getDataTotal() {
        return this.dataCount;
    }


    savePacsInfo(pacsInfo: PacsInfo) {

        this.dataSource.savePacsInfo(pacsInfo).subscribe(p => {
            if(p.status == '1') {
                this.event.sendAddSubjectSubjectMessage(p.resultInfo.P_ID);
            } else {
                this.event.sendAddSubjectSubjectMessage(p.errmsg);
            }
            
        });


    }



    deletePatient(id: string) {
        this.dataSource.deletePatient(id).subscribe(p => {
            console.log(p);
            if(p.status == '1') {
                //通知重新更新列表
                this.pacsList.splice(this.pacsList.findIndex(p => p.P_ID == id), 1);
                this.event.sendPacsListMessage('002');
            } else {
                this.event.sendPacsListMessage('003');
            }
        })

    }

    deleteFile(P_ID, F_ID) {
        this.dataSource.deleteFile(P_ID, F_ID).subscribe(p => {
            console.log(p);
            if(p.status == '1') {
                let fileList  = this.pacsList[this.pacsList.findIndex(p => p.P_ID == P_ID)].fileList;
                fileList.splice(fileList.findIndex(p => p.F_ID == F_ID), 1);
                this.pacsList[this.pacsList.findIndex(p => p.P_ID == P_ID)].fileList = fileList;
                this.event.sendDeleteFileMessage(F_ID);
            } else {
                this.event.sendDeleteFileMessage('002');
            }
        })

    }

}